import $ from 'jquery';
import Base from '../../../_config/base';
//import ScrollTo from '../../../materials/molecules/scroll-to/scroll-to';

class Accordion extends Base {
  constructor(el) {
    super(el);
    this.openClass = 'accordion--open';
    this.items = this.$el.find('.accordion__item');
    this.offset = this.$el.data('scroll-offset');
    this.$el.find('.accordion__title').on('click', this.toggleItem.bind(this));
    this.$el.find('.accordion__content a').each(this.addIcon);
    this.$el.find('.accordion__title:first').click();
  }

  toggleItem(e) {
    e.preventDefault();
    const item = $(e.target).closest('.accordion__item');
    const currentOpen = item.hasClass(this.openClass);

    this.items.removeClass(this.openClass);
    if (!currentOpen) {
      item.toggleClass(this.openClass);
    }

    //return ScrollTo.to(item, this.offset);
    return true;
  }

  addIcon() {
    $(this).append('<svg class="icon icon--arrow-left" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <use xlink:href="#icon--arrow-left"></use> </svg>');
  }
}

Accordion.className = 'Accordion';
export default Accordion;



// WEBPACK FOOTER //
// ./src/materials/molecules/accordion/accordion.js